import style from "./RadioButton.module.css"

function RadioButton(props){

    return (
        <div className={'form-check'}>
            <input type={"radio"}
                   id={props.id}
                   onChange={props.onChange}
                   checked={props.checked}
                   disabled={props.disabled}
                   style={props.style}
                   value={props.value}
                   className={style.radioButtonCustom}
            />
            <label className={"ml-2"} htmlFor={props.id ? props.id : 'radio1'} >
                <span style={{verticalAlign: "text-bottom"}} className={props.classNameText ? props.classNameText : null}>
                    {props.text}
                </span>
            </label>
        </div>


    )


}
export default RadioButton
